import React from 'react';
import Brand from './Brand';

export default function () {
  return (
    <div className="top-brand float-left">
      <Brand/>
    </div>
  );
}
